import { useEffect, useState } from "react";
import {
  deleteContent,
  // getContent,
} from "../../../crud/api/content.crud";
import { setAlert } from "../../../../redux/ducks/alert.duck";
import { useContentsContext } from "./useContentsContext.hook";
import { useContents } from "./useContents.hook";
import { useCategories } from "./useCategories.hook";
import { useContribuitingFactors } from "./useContribuitingFactors.hook";
import { useFocusAreas } from "./useFocusAreas.hook";
import { useTags } from "./useTags.hook";

const useContentsMaintenance = ({
  contentActions,
  settingLoader,
  setLoader,
  school,
}) => {
  const [htmlContent, setHtmlContent] = useState("");
  const [dialog, setDialog] = useState("close");
  const [notify, setNotify] = useState(false);

  const {
    allCategories,
    categories,
    filterCategories,
    isProAthleteContent,
    setIsProAthleteContent,
    setContent,
    page,
    setPage,
    query,
    setQuery,
    setZoneId,
    zoneId,
    contentsList,
    resetValues_Content,
  } = useContentsContext();

  const { getContentsx, getContentx } = useContents({});
  const { getCategories } = useCategories({});
  const { getFactors } = useContribuitingFactors({});
  const { getFocusAreas } = useFocusAreas({});
  const { getTags } = useTags({});

  const openDialog = async (mode, id = null) => {
    switch (mode) {
      case "create":
        resetValues_Content();
        setDialog(mode);
        //contentActions.setContent(defaultContent);
        break;
      case "editing":
        settingLoader(true);
        try {
          await getContentx(id);
          //await getContent(contentActions.setContent, id);
          setDialog(mode);
        } catch (error) {
          console.error("Failed to get content:", error);
        }
        break;
      case "close":
        setDialog(mode);
        setTimeout(() => {
          //contentActions.setContent(defaultContent);
          resetValues_Content();
        }, 500);
        break;
      default:
        console.error("Invalid dialog mode");
    }
  };

  const handleOpenNotify = async (id) => {
    await getContentx(id);
    //await getContent(setContent, id);
    setNotify(true);
  };

  const deleteCont = (id) => {
    setAlert({
      title: "Delete Content",
      message: "Are you sure to permanently delete this Content?",
      btn_msg: "Delete Content",
      action: () =>
        deleteContent(id).then(async () => {
          await getContentsx();
        }),
    });
  };

  const setCategoriesTabs = () => filterCategories(isProAthleteContent);

  const onSearch = async () => {
    await getContentsx();
  };
  const onGetContents = async () => {
    await getContentsx();
  };

  useEffect(() => {
    getCategories();
    getFactors();
    getFocusAreas();
    getTags(1, school?.slug, 200);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setCategoriesTabs();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [allCategories, isProAthleteContent]);

  useEffect(() => {
    if (categories.length > 0) {
      setZoneId(categories[0].key);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [categories]);

  useEffect(() => {
    if (zoneId == null) return;
    settingLoader(true);
    getContentsx();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [setContent, page, zoneId, query, settingLoader, isProAthleteContent]);

  return {
    deleteCont,
    openDialog,
    htmlContent,
    setHtmlContent,
    dialog,
    setDialog,
    setNotify,
    page,
    setPage,
    tabValue: zoneId,
    onSearch,
    onGetContents,
    setIsProAthleteContent,
    isProAthleteContent,
    setTabValue: setZoneId,
    query,
    setQuery,
    categories,
    notify,
    handleOpenNotify,
    contentsList,
  };
};

export default useContentsMaintenance;
